/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useMemo } from 'react';
import _ from 'lodash';
import { useTranslator } from '@jutro/locale';

import messages from './MLDocumentRecipients.messages';

function MLChosenRecipientsTable(props){
    const {
        chosenRecipients,
        removeRecipient,
        getContactDisplayName,
        viewModelService
    } = props;

    const translator = useTranslator();

    const distributionMethodOptions = useMemo(() => {
        const typekey = viewModelService.productMetadata.get('pc').types.getTypelist('DocDistributionMethod_Ext');
        return typekey.codes.map((code) => {
            return {
                code: code.code,
                name: translator({id: code.name, defaultMessage: code.name})
            }
        })
    }, [translator, viewModelService.productMetadata]);

    const getDistributionMethodText = (distributionMethod) => {
        return _.find(distributionMethodOptions, { code: distributionMethod }).name;
    }

    return(
        <table className="table table-striped">
            <thead>
                <tr>
                    <th>{translator(messages.recipient)}</th>
                    <th>{translator(messages.deliveryMethod)}</th>
                    <th>{translator(messages.actions)}</th>
                </tr>
            </thead>
            <tbody>
                {chosenRecipients.map((recipient) => 
                    <tr>
                        <td>{getContactDisplayName(recipient.contact)}</td>
                        <td>{getDistributionMethodText(recipient.distributionMethod)}</td>
                        <td>
                            <a onClick={(() => removeRecipient(recipient))}>
                                {translator(messages.remove)}
                            </a>
                        </td>
                    </tr>
                )}
                {(!chosenRecipients || chosenRecipients.length === 0) && 
                    <tr>
                        <td colSpan="3">
                            {translator(messages.noRecipientsAdded)}
                        </td>
                    </tr>
                }
            </tbody>
        </table>
    )
}

export default MLChosenRecipientsTable